import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { ReferenceCardComponent } from 'libs/shared/ui-common/src/lib/components/reference-card/reference-card.component';

import { DIALOG_DATA, NodeDetailPopoverData, POPOVER_DATA, ReferenceWithNumber } from '@treetop/shared/model';

@Component({
  selector: 'tt-node-detail-popover-references',
  standalone: true,
  imports: [TranslocoModule, ReferenceCardComponent],
  templateUrl: './node-detail-popover-references.component.html',
  styleUrl: './node-detail-popover-references.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NodeDetailPopoverReferencesComponent implements OnInit {
  @Input() public references: ReferenceWithNumber[];

  private popoverData: NodeDetailPopoverData = inject(POPOVER_DATA, { optional: true });
  protected dialogData: NodeDetailPopoverData = inject(DIALOG_DATA, { optional: true });
  protected data: NodeDetailPopoverData = this.dialogData ?? this.popoverData;

  public ngOnInit(): void {
    if (!this.references && this.data.references) {
      this.references = this.data.references;
    }
  }
}
